'use client';

import { NATIVE_LOGIN_EVENT, NATIVE_LOGOUT_EVENT } from '@shared/native';
import { useEffect, useRef } from 'react';
import { useSession } from '../../providers/SessionProvider';

const LOGIN_SUCCESS_PARAM = 'login_success';
const LOGOUT_SUCCESS_PARAM = 'logout_success';

function AuthEvents() {
  const { session } = useSession();
  const loginSuccessRef = useRef<boolean | null>(null);
  const logoutSuccessRef = useRef<boolean | null>(null);
  const loginEmittedRef = useRef(false);
  const logoutEmittedRef = useRef(false);

  useEffect(() => {
    if (loginSuccessRef.current === null || logoutSuccessRef.current === null) {
      const searchParams = new URLSearchParams(window.location.search);
      loginSuccessRef.current = searchParams.get(LOGIN_SUCCESS_PARAM) === 'true';
      logoutSuccessRef.current = searchParams.get(LOGOUT_SUCCESS_PARAM) === 'true';
    }

    if (logoutSuccessRef.current && !logoutEmittedRef.current) {
      logoutEmittedRef.current = true;
      window.dispatchEvent(new CustomEvent(NATIVE_LOGOUT_EVENT));
    }

    if (loginEmittedRef.current || !loginSuccessRef.current) return;
    if (session.status !== 'authenticated') return;

    const playerId = session.profile?.id;
    if (!playerId) return;

    loginEmittedRef.current = true;
    window.dispatchEvent(new CustomEvent(NATIVE_LOGIN_EVENT, { detail: { playerId } }));
  }, [session.profile?.id, session.status]);

  return null;
}

export { AuthEvents };
